// extracted by mini-css-extract-plugin
module.exports =  {"noteOld":"xN8KUl","button":"gc6fSV","body":"iKsFsS","icon":"L9QG3X"};